"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=fin-discount-rule.dto.js.map